<div class="container">
  <ul class="breadcrumb">
    <li><strong>Onde estou:</strong></li>
    <li class="active">
      <span id="lblSubMenu">Cadastro - Postos - <b>Ajuste Preços Combustível</b></span>
    </li>
  </ul>

  <div class="container-tela">
     <div class="card" *ngIf="precosCombustiveisDesatualizados">
      <div class="card-header combustivel-atrasado">
        <h2>Atenção!</h2>
      </div>
      <div class="card-body">
        <div class="col-md-8 offset-md-2 ">
          <h3>Verificamos que o seu preço não foi informado a mais de 7 dias, favor confirmar ou atualizar os valores.</h3>
          <button class="btn btn-terceary" (click)="confirmarPrecosAtuais()">Confirmar preços <span class="fa fa-question"></span></button>

        </div>
      </div>
      <div class="card-footer combustivel-atrasado">
      </div>
    </div> 

    <app-modal-ajuda></app-modal-ajuda>
    <app-menu-combustiveis
      *ngIf="listaCombustiveis" [listaCombustiveis]="listaCombustiveis"
      (alterarCombustivel)="combustivelAlterado($event)">
    </app-menu-combustiveis>

    <app-notificacoes
      *ngIf="mensagens" [notificacaoMensagens]="mensagens"
      [notificacaoStatus]="statusSucesso"
      (fecharNotificacoes)="mensagens = []">

    </app-notificacoes>




    <app-mostrar-preco
      *ngIf="combustivel"
      [combustivel]="combustivel"
      (combustivelParaAlterar)="alterarPrecoCombustivel($event)"
      (habilitarDesabilitarCombustivel)="habilitarDesabilitarCombustivel($event)"
    >
    </app-mostrar-preco>

    <app-mat-spinner-overlay
      [overlay]="true" *ngIf="this.loading">
    </app-mat-spinner-overlay>

    <ng-template #content class="modal-ativo">
      <app-modal-ajuste-preco-unitario
        [combustivel]="combustivel" *ngIf="tipoPrecoSendoAlterado === 'precoUnitario'"
        (salvarModificacoes)="salvarMods($event)">
      </app-modal-ajuste-preco-unitario>

      <app-modal-ajuste-preco-negociado
        [combustivel]="combustivel" *ngIf="tipoPrecoSendoAlterado === 'precoNegociado'"
        (salvarModificacoes)="salvarMods($event)">
      </app-modal-ajuste-preco-negociado>

      <app-modal-ajuste-preco-rede-especial
      [combustivel]="combustivel" *ngIf="tipoPrecoSendoAlterado === 'precoRedeEspecial'"
      (salvarModificacoes)="salvarMods($event)">
    </app-modal-ajuste-preco-rede-especial>

    </ng-template>


  </div>
</div>
